package org.gstechnovos.jexonplastech.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.styles.NavigationItemStyle
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Res
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*

@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun OverFlowMenu(
    onMenuClosed: () -> Unit
) {
    val scope = rememberCoroutineScope()
    val breakPoint = LocalBreakpoint.current

    var translateX by remember { mutableStateOf(-100.percent) }
    var opacity by remember { mutableStateOf(0.percent) }

    LaunchedEffect(breakPoint) {
        translateX = 0.percent
        opacity = 100.percent
        if(breakPoint > Breakpoint.MD) {
            scope.launch {
                translateX = (-100).percent
                opacity = 0.percent
                delay(500)
                onMenuClosed()
            }
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth().height(100.vh).position(Position.Fixed).zIndex(2).opacity(opacity)
            .backgroundColor(argb(a = 0.5f, r = 0.0f, g = 0.0f, b = 0.0f)).transition {
                Transition(property = "opacity", duration = 500.ms)
            },
    ) {
        Column(
            modifier = Modifier.fillMaxHeight().padding(25.px)
                .width(if (breakPoint < Breakpoint.MD) 50.percent else 25.percent)
                .overflow(Overflow.Auto)
                .scrollBehavior(ScrollBehavior.Smooth)
                .backgroundColor(Colors.White).translateX(tx=translateX)
                .transition { Transition(property = "translateX", duration = 500.ms) }
        ) {
            Row(
                modifier = Modifier.margin(bottom = 25.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaXmark(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .margin(
                            right = 20.px,
                            bottom = 3.px
                        )
                        .onClick {
                            scope.launch {
                                translateX= (-100).percent
                                opacity = 0.percent
                                delay(500)
                                onMenuClosed()
                            }
                        },
                    size = IconSize.LG
                )
                Image(
                    modifier = Modifier.height(50.px),
                    src = Res.Image.LOGO,
                    description = "logo"
                )
            }

            Section.entries.take(6).forEach { section ->
                Link(
                    modifier = NavigationItemStyle.toModifier()
                        .margin(bottom = 10.px)
                        .fontSize(16.px)
                        .fontWeight(FontWeight.Normal)
                        .textDecorationLine(TextDecorationLine.None)
                        .onClick {
                            scope.launch {
                                translateX= (-100).percent
                                opacity = 0.percent
                                delay(500)
                                onMenuClosed()
                            }
                        },
                    path = section.path,
                    openExternalLinksStrategy = OpenLinkStrategy.IN_PLACE,
                    text = section.title
                )

            }
        }
    }
}